import React from 'react';

export default function SearchBar({ url, setUrl, onScan, loading }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      onScan();
    }
  };

  return (
    <section className="search-section">
      <div className="search-container">
        <div className="search-input-wrapper">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            className="search-input"
            placeholder="Cole uma URL para análise (ex: https://exemplo.com)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={loading}
            autoFocus
          />
          <button
            className="search-btn"
            onClick={onScan}
            disabled={loading || !url.trim()}
          >
            {loading ? (
              <>
                <span className="spinner" />
                Analisando...
              </>
            ) : (
              <>🔬 Analisar URL</>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}
